import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import { SectionHeader } from "../../../components/sectionHeader/SectionHeader";
import { ColorPickerPreview } from "../../../components/colorPicker/ColorPickerPreview";
import ColorPicker, {
  getHex,
} from "../../../components/colorPicker/ColorPicker";

export const Color = ({ color: hexColor, onChange }) => {
  const [color, setColor] = useState(hexColor);

  useEffect(() => {
    setColor(hexColor);
  }, [hexColor]);

  const changeColor = (newColor) => {
    /**
     * @param newColor - it can be hex, hsv or hsl
     */
    setColor(newColor);
    onChange(getHex(newColor));
  };

  return (
    <fieldset className="branding__color col-md-6">
      <SectionHeader title={<FormattedMessage id={"icon_and_link_color"} />} />
      <div className={"branding__color__content"}>
        <div className={"picker"}>
          <div id="color-picker-label" className="picker__label">
            <FormattedMessage id="selected_color" />
          </div>
          <ColorPicker
            color={color}
            onColorChange={changeColor}
            ariaLabelledBy="color-picker-label"
          />
        </div>
        <div className={"preview"}>
          <div className={"preview__label"}>
            <FormattedMessage id={"preview"} />
          </div>
          <ColorPickerPreview color={hexColor} />
        </div>
      </div>
    </fieldset>
  );
};

Color.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
